export const syntaxCheckRegional = `query syntaxCheckRegional($kmatID: String!) {
  syntaxCheckRegional(kmatID: $kmatID) 
  }`;
